import React from 'react'
import { Component } from 'reflux'
import { PurchaseOrderStore, PurchaseOrderStoreActions, STATUS } from '../../stores/purchaseOrderStore'
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TableFooter,
  IconButton,
  Tooltip,
  CircularProgress,
  Typography,
  Box,
  Chip,
  TextField,
  Tabs,
  Tab,
  TablePagination,
  Checkbox,
  Button
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import VisibilityIcon from '@material-ui/icons/Visibility'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import PurchaseOrderPrepaymentSummary from './purchaseOrderPrepaymentSummary'
import { canMarkPurchaseOrderPaid, isPrepayOrder, purchaseOrderStatusLabel } from '../../util/purchaseOrderWorkflow'

const statusTabs = [
  { label: 'Alle', value: 'ALL' },
  { label: 'Nye', value: 'NEW' },
  { label: 'Afventer forudbetaling', value: 'AWAITING_PREPAYMENT' },
  { label: 'På vej', value: 'SENT' },
  { label: 'Delvist modtaget', value: 'PARTLY_RECEIVED' },
  { label: 'Modtaget', value: 'RECEIVED' },
  { label: 'Lukket', value: 'CLOSED' }
]

export default class PurchaseOrderAll extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['purchaseOrders', 'status', 'purchaseOrdersTotalCount', 'purchaseOrdersQuery', 'payingPurchaseOrderID']

    this.state = {
      ...this.state,
      search: '',
      tab: 'ALL',
      page: 0,
      rowsPerPage: 10,
      selectedPOs: []
    }
  }

  componentDidMount() {
    const q = this.state.purchaseOrdersQuery || {}
    const search = q.searchTerm || this.state.search
    const tab = (Array.isArray(q.statusIn) && q.statusIn.length ? q.statusIn[0] : 'ALL') || 'ALL'
    const page = Math.max(0, (q.page || 1) - 1)
    const rowsPerPage = q.pageSize || this.state.rowsPerPage

    this.setState({ search, tab, page, rowsPerPage }, () => {
      const hasData = Array.isArray(this.state.purchaseOrders) && this.state.purchaseOrders.length > 0
      if (!hasData) {
        const payload = Object.keys(q).length
          ? q
          : {
              page: this.state.page + 1,
              pageSize: this.state.rowsPerPage,
              searchTerm: this.state.search,
              sortField: 'PurchaseOrderNumber',
              sortDir: 'DESC',
              statusIn: this.state.tab === 'ALL' ? [] : [this.state.tab]
            }
        PurchaseOrderStoreActions.getPurchaseOrdersPaged(payload)
      }
    })
  }

  stateFromStoreQuery() {
    return {
      page: this.state.page + 1,
      pageSize: this.state.rowsPerPage,
      searchTerm: this.state.search,
      sortField: 'PurchaseOrderNumber',
      sortDir: 'DESC',
      statusIn: this.state.tab === 'ALL' ? [] : [this.state.tab]
    }
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Kunne ikke hente indkøbsordrer', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Kunne ikke slette indkøbsordre', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('Indkøbsordre slettet', {
        autoClose: 7500,
        onClose: () => {
          PurchaseOrderStoreActions.clearToast()
        }
      })
      PurchaseOrderStoreActions.clearToast()
    }
  }

  handleDelete = PurchaseOrderID => {
    if (window.confirm('Vil du slette denne indkøbsordre?')) {
      PurchaseOrderStoreActions.deletePurchaseOrder(PurchaseOrderID)
    }
  }

  handleSearchChange = e => {
    const search = e.target.value
    this.setState({ search, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersQuery({
      page: 1,
      pageSize: this.state.rowsPerPage,
      searchTerm: search,
      sortField: 'PurchaseOrderNumber',
      sortDir: 'DESC',
      statusIn: this.state.tab === 'ALL' ? [] : [this.state.tab]
    })
  }

  handleTabChange = (e, value) => {
    this.setState({ tab: value, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersQuery({
      page: 1,
      pageSize: this.state.rowsPerPage,
      searchTerm: this.state.search,
      sortField: 'PurchaseOrderNumber',
      sortDir: 'DESC',
      statusIn: value === 'ALL' ? [] : [value]
    })
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage })
    PurchaseOrderStoreActions.setPurchaseOrdersQuery({
      page: newPage + 1,
      pageSize: this.state.rowsPerPage,
      searchTerm: this.state.search,
      sortField: 'PurchaseOrderNumber',
      sortDir: 'DESC',
      statusIn: this.state.tab === 'ALL' ? [] : [this.state.tab]
    })
  }

  handleChangeRowsPerPage = event => {
    const rowsPerPage = parseInt(event.target.value, 10)
    this.setState({ rowsPerPage, page: 0 })
    PurchaseOrderStoreActions.setPurchaseOrdersQuery({
      page: 1,
      pageSize: rowsPerPage,
      searchTerm: this.state.search,
      sortField: 'PurchaseOrderNumber',
      sortDir: 'DESC',
      statusIn: this.state.tab === 'ALL' ? [] : [this.state.tab]
    })
  }

  handleSelectPO = po => {
    const { selectedPOs } = this.state
    const isSelected = selectedPOs.some(sel => sel.PurchaseOrderID === po.PurchaseOrderID)
    let nextSelected
    if (isSelected) {
      nextSelected = selectedPOs.filter(sel => sel.PurchaseOrderID !== po.PurchaseOrderID)
    } else {
      // Only allow max 2, and same supplier
      if (selectedPOs.length === 2) return
      if (selectedPOs.length === 1 && selectedPOs[0].supplier?.SupplierID !== po.supplier?.SupplierID) {
        toast.error('Du kan kun vælge indkøbsordrer fra samme leverandør.')
        return
      }
      if (selectedPOs.length === 1 && isPrepayOrder(selectedPOs[0]) !== isPrepayOrder(po)) {
        toast.error('Indkøbsordrer med forskellige betalingsbetingelser kan ikke flettes.')
        return
      }
      nextSelected = [...selectedPOs, po]
    }
    this.setState({ selectedPOs: nextSelected })
  }

  handleMergePOs = async () => {
    const { selectedPOs } = this.state
    if (selectedPOs.length !== 2) return
    if (!window.confirm('Er du sikker på, at du vil flette disse indkøbsordrer?')) return
    try {
      await PurchaseOrderStoreActions.mergePurchaseOrders(selectedPOs.map(po => po.PurchaseOrderID))
      toast.success('Indkøbsordrer flettet.')
      this.setState({ selectedPOs: [] })
    } catch (err) {
      toast.error('Kunne ikke flette indkøbsordrer.')
    }
  }

  filterOrders(orders, search, tab) {
    let filtered = orders
    if (tab && tab !== 'ALL') {
      filtered = filtered.filter(po => po.purchaseOrderStatus === tab)
    }
    if (search) {
      const s = search.toLowerCase()
      filtered = filtered.filter(
        po =>
          (po.supplier?.supplierName || '').toLowerCase().includes(s) ||
          (po.supplier?.supplierUID || '').toLowerCase().includes(s) ||
          String(po.purchaseOrderNumber || '')
            .toLowerCase()
            .includes(s)
      )
    }
    return filtered
  }

  handleMarkPaid = po => {
    if (window.confirm(`Bekræft, at hele beløbet for indkøbsordre ${po.purchaseOrderNumber} er betalt. Ordren flyttes til På vej.`)) {
      PurchaseOrderStoreActions.markPurchaseOrderPaid(po)
    }
  }

  render() {
    const pagedOrders = this.state.purchaseOrders || []
    const totalCount = this.state.purchaseOrdersTotalCount || 0
    const { page, rowsPerPage, selectedPOs, tab } = this.state
    const stickyActionsStyle = {
      whiteSpace: 'nowrap',
      position: 'sticky',
      right: 0,
      background: '#fff',
      boxShadow: '-2px 0 4px rgba(0,0,0,0.08)'
    }

    return (
      <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 8 }}>
        <Box display='flex' alignItems='center' justifyContent='space-between' flexWrap='wrap' gridGap={8} mb={2}>
          <Typography variant='h6'>Indkøbsordre oversigt</Typography>
          <TextField
            label='Søg leverandør, CVR eller PO nr.'
            variant='outlined'
            size='small'
            value={this.state.search}
            onChange={this.handleSearchChange}
            style={{ width: 300, maxWidth: '100%' }}
          />
        </Box>
        <Tabs
          value={this.state.tab}
          onChange={this.handleTabChange}
          indicatorColor='primary'
          textColor='primary'
          variant='scrollable'
          scrollButtons='auto'
          style={{ marginBottom: 16, backgroundColor: '#f5f5f5' }}
        >
          {statusTabs.map(tab => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        {tab === 'AWAITING_PREPAYMENT' && <PurchaseOrderPrepaymentSummary />}
        {tab === 'NEW' && (
          <Box mb={2} display='flex' alignItems='center' justifyContent='end' gap={2}>
            <Typography variant='body2'></Typography>
            <Button variant='contained' color='primary' disabled={selectedPOs.length !== 2} onClick={() => this.handleMergePOs()}>
              Flet valgte
            </Button>
          </Box>
        )}
        <TableContainer>
          <Table size='small' style={{ minWidth: 1100 }}>
            <TableHead>
              <TableRow>
                {tab === 'NEW' && <TableCell />}
                <TableCell style={{ whiteSpace: 'nowrap' }}>PO Nummer</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Firma</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Oprettelses dato</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Ordre type</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Betaling</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Beløb</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap' }}>Antal Produkter</TableCell>
                <TableCell style={{ width: 150, minWidth: 150, maxWidth: 150, whiteSpace: 'nowrap' }}>Status</TableCell>
                <TableCell align='right' style={{ ...stickyActionsStyle, zIndex: 2 }}>
                  Handlinger
                </TableCell>
              </TableRow>
            </TableHead>
            {this.state.status === STATUS.IS_FETCHING ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={100} align='center'>
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {pagedOrders.map(po => {
                  const totalAmount = (po.purchaseOrderlines || []).reduce((sum, l) => sum + (l.pricePerItem || 0) * (l.amountOfProducts || 0), 0)
                  const productCount = (po.purchaseOrderlines || []).length

                  let chipStyle = {}
                  if (po.purchaseOrderStatus === 'NEW') chipStyle = { background: '#e0e0e0', color: '#222' }
                  if (po.purchaseOrderStatus === 'SENT') chipStyle = { background: '#1976d2', color: '#fff' }
                  if (po.purchaseOrderStatus === 'AWAITING_PREPAYMENT') chipStyle = { background: '#fff3cd', color: '#664d03' }
                  if (po.purchaseOrderStatus === 'RECEIVED') chipStyle = { background: '#388e3c', color: '#fff' }
                  if (po.purchaseOrderStatus === 'PARTLY_RECEIVED') chipStyle = { background: 'orange', color: '#fff' }
                  if (po.purchaseOrderStatus === 'CLOSED') chipStyle = { background: '#616161', color: '#fff' }

                  const isSelected = selectedPOs.some(sel => sel.PurchaseOrderID === po.PurchaseOrderID)
                  return (
                    <TableRow key={po.purchaseOrderNumber}>
                      {tab === 'NEW' && (
                        <TableCell>
                          <Checkbox
                            checked={isSelected}
                            onChange={() => this.handleSelectPO(po)}
                            disabled={
                              !isSelected &&
                              (selectedPOs.length === 2 ||
                                (selectedPOs.length === 1 && selectedPOs[0].supplier?.SupplierID !== po.supplier?.SupplierID))
                            }
                          />
                        </TableCell>
                      )}
                      <TableCell style={{ whiteSpace: 'nowrap' }}>{po.purchaseOrderNumber}</TableCell>
                      <TableCell style={{ minWidth: 180 }}>
                        {po.supplier?.supplierName}
                        <br />
                        <span style={{ fontSize: 12, color: '#888' }}>CVR: {po.supplier?.corporateIdentificationNumber}</span>
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        {po.dateCreated ? new Date(po.dateCreated).toLocaleDateString('da-DK') : 'Ikke angivet'}
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>{po.isDropShip ? 'Dropship' : 'Almindelig'}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        {isPrepayOrder(po) ? (po.prepaidAt ? 'Forudbetalt' : 'Forudbetaling') : 'Normal betaling'}
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        {totalAmount.toLocaleString('da-DK', { minimumFractionDigits: 2 })} {po.currency || 'DKK'}
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>{productCount}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        <Chip label={purchaseOrderStatusLabel(po.purchaseOrderStatus)} style={chipStyle} size='small' />
                      </TableCell>
                      <TableCell align='right' style={stickyActionsStyle}>
                        {canMarkPurchaseOrderPaid(po) && (
                          <Tooltip title='Markér som betalt'>
                            <IconButton
                              size='small'
                              style={{ color: '#2e7d32' }}
                              disabled={!!this.state.payingPurchaseOrderID}
                              onClick={() => this.handleMarkPaid(po)}
                            >
                              <MonetizationOnIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title='Vis'>
                          <IconButton component={Link} to={`/purchase-orders/details/${po.PurchaseOrderID}`} size='small' color='primary'>
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title='Slet'>
                          <IconButton color='secondary' size='small' onClick={() => this.handleDelete(po.PurchaseOrderID)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            )}

            {(!pagedOrders || pagedOrders.length === 0) && this.state.status !== STATUS.IS_FETCHING && (
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={tab === 'NEW' ? 10 : 9} align='center'>
                    <Typography variant='body2' color='textSecondary'>
                      Ingen indkøbsordrer fundet.
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableFooter>
            )}
          </Table>
        </TableContainer>
        <TablePagination
          component='div'
          count={totalCount}
          page={page}
          onPageChange={this.handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          labelRowsPerPage='Rækker pr. side'
        />
      </Paper>
    )
  }
}
